function getDeliveryDateRange() {
    let today = new Date();
    let startDate = new Date(today);
    let endDate = new Date(today);

    startDate.setDate(today.getDate() + 1); // e.g., 1 days from now
    endDate.setDate(today.getDate() + 5);   // e.g., 5 days from now

    let options = { weekday: 'long', month: 'long', day: 'numeric' };

    let deliveryMessage = `Estimated Delivery: ${startDate.toLocaleDateString('en-US', options)} - ${endDate.toLocaleDateString('en-US', options)}`;

    return deliveryMessage;
}

document.addEventListener('DOMContentLoaded', function() {
    let message = getDeliveryDateRange();
    let deliveryEl = document.createElement('div');
    deliveryEl.className = 'delivery-date';
    deliveryEl.textContent = message;

    let target = document.querySelector('.shopify-payment-button, .product-single__meta');
    if (target) {
        target.appendChild(deliveryEl);
    }
});